"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileV = require("@/mixins/last-mile-v2/last-mile-v2");

var _orderV = require("@/api/order-v2.api");

var _fullscreen = _interopRequireDefault(require("@/components/fullscreen/fullscreen.vue"));

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _orderTableColumnSelector = _interopRequireDefault(require("../order-table-column-selector/order-table-column-selector.vue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PAGE_SIZE_KEY = 'pageSize';

var LMDOrderTableComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderTableComponent, _Mixins);

  var _super = _createSuper(LMDOrderTableComponent);

  function LMDOrderTableComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderTableComponent);
    _this = _super.apply(this, arguments);
    _this.moment = _moment.default;
    _this.buffer = {};
    _this.selectedColumns = [];
    _this.orderAPI = null;
    _this.isShowMap = false;
    return _this;
  }

  (0, _createClass2.default)(LMDOrderTableComponent, [{
    key: "onPageSizeChanges",
    value: function onPageSizeChanges(newVal) {
      window.localStorage.setItem(PAGE_SIZE_KEY, newVal);
    }
  }, {
    key: "onUnassignedOrdersChanges",
    value: function onUnassignedOrdersChanges() {
      var _this2 = this;

      this.logger.info('Watch $unassignedOrders');
      this.$nextTick(function () {
        var ordersIntersection = _this2.helper.intersectionBy(_this2.$unassignedOrders, _this2.$selectedOrders, 'id');

        _this2.toggleRowsSelection(ordersIntersection);
      });
    }
  }, {
    key: "$currentPage",
    get: function get() {
      return this.$store.getters['lastMileV2/pagination']['currentPage'];
    }
  }, {
    key: "$totalData",
    get: function get() {
      return this.$store.getters['lastMileV2/pagination']['totalData'];
    }
  }, {
    key: "$pageSize",
    get: function get() {
      return this.$store.getters['lastMileV2/pagination']['pageSize'];
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.orderAPI) {
        this.orderAPI = new _orderV.OrderV2API({
          lfToken: this.$lfToken || null,
          userSetting: this.$userSetting,
          userData: this.$userData
        });
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var pageSize = window.localStorage.getItem(PAGE_SIZE_KEY);

      if (!this.helper.isUndefined(pageSize)) {
        var p = _objectSpread({}, this.$pagination);

        p.pageSize = parseInt(pageSize, 10);
        this.$setPagination(p);
        this.logger.info('mounted orderTable- Set pagination', JSON.stringify(this.$pagination));
      }
    }
  }, {
    key: "handlePagination",
    value: function () {
      var _handlePagination = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, type) {
        var p;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                p = _objectSpread({}, this.$pagination);

                if (type === 'sizeChange') {
                  p.currentPage = 1;
                  p.pageSize = val;
                }

                if (type === 'currentChange') {
                  p.currentPage = val;
                }

                this.$setPagination(p);
                this.logger.info('handlePagination - Set pagination', JSON.stringify(this.$pagination));
                this.logger.info('handlePagination - Get Unassigned Orders');
                _context.next = 8;
                return this.$getUnassignedOrders();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handlePagination(_x, _x2) {
        return _handlePagination.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: "tableRowClassName",
    value: function tableRowClassName(_ref) {
      var row = _ref.row;
      var errorBool = this.isInvalidOrder(row);
      var selectedBool = false;

      if (this.helper.find(this.$selectedOrders, {
        shipmentReference: row.shipmentReference
      })) {
        selectedBool = true;
      } // Socket for global orders


      if (this.isOrderIdExistInGlobal(row.id)) {
        return 'used-row';
      }

      return !errorBool ? selectedBool ? 'success-row cursor-pointer' : 'cursor-pointer' : selectedBool ? 'error-row' : 'warning-row';
    }
  }, {
    key: "handleSort",
    value: function () {
      var _handleSort = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
        var column, prop, order, p;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                column = _ref2.column, prop = _ref2.prop, order = _ref2.order;

                if (!(prop !== null && prop !== undefined)) {
                  _context2.next = 11;
                  break;
                }

                p = _objectSpread({}, this.$pagination);

                if (order === 'ascending') {
                  p.order = 'ASC';
                }

                if (order === 'descending') {
                  p.order = 'DESC';
                }

                p.orderBy = prop;
                this.$setPagination(p);
                this.logger.info('handleSort - Set pagination', JSON.stringify(this.$pagination));
                this.logger.info('handleSort - Get Unassigned Orders');
                _context2.next = 11;
                return this.$getUnassignedOrders();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSort(_x3) {
        return _handleSort.apply(this, arguments);
      }

      return handleSort;
    }()
  }, {
    key: "isRowSelectable",
    value: function isRowSelectable(row, index) {
      return !this.isInvalidOrder(row) && !this.isOrderIdExistInGlobal(row.id);
    }
  }, {
    key: "selectClickHandler",
    value: function selectClickHandler($event, row) {
      var _this3 = this;

      // Socket for global orders
      this.socketAPI.updateLMDGlobalSelectedOrders({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        orderId: [row.id],
        dataType: this.helper.findIndex(this.$selectedOrders, function (o) {
          return o['id'] === row['id'];
        }) === -1 ? 'add' : 'remove'
      });
      this.$selectedOrders = this.helper.findIndex(this.$selectedOrders, function (o) {
        return o['id'] === row['id'];
      }) === -1 ? this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), [row]), 'id') : this.helper.filter(this.$selectedOrders, function (o) {
        return o['id'] !== row['id'];
      });
      this.$selectedOrders.map(function (o) {
        var idx = _this3.helper.findIndex(_this3.$unassignedOrders, function (i) {
          return i['id'] === o['id'];
        });

        if (_this3.helper.isUndefined(o['tableIndex'])) {
          o['tableIndex'] = _this3.tableIndex(idx);
        }
      });
    }
  }, {
    key: "selectAllHandler",
    value: function selectAllHandler($event) {
      var _this4 = this;

      var currentPage = this.$currentPage;
      var prevBuffer = this.helper.cloneDeep(this.buffer[currentPage]);

      if ($event.length > 0) {
        this.buffer[currentPage] = this.helper.cloneDeep($event);
        this.$selectedOrders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), (0, _toConsumableArray2.default)($event)), 'id');
      } else {
        this.$selectedOrders = this.helper.differenceBy(this.$selectedOrders, this.buffer[currentPage], 'id');
        this.buffer[currentPage] = this.helper.cloneDeep($event);
      }

      this.$selectedOrders.map(function (o) {
        var idx = _this4.helper.findIndex(_this4.$unassignedOrders, function (i) {
          return i['id'] === o['id'];
        });

        if (_this4.helper.isUndefined(o['tableIndex'])) {
          o['tableIndex'] = _this4.tableIndex(idx);
        }
      }); // Socket for global orders

      this.socketAPI.updateLMDGlobalSelectedOrders({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        orderId: $event.length > 0 ? this.buffer[currentPage].map(function (o) {
          return o['id'];
        }) : prevBuffer.map(function (o) {
          return o['id'];
        }),
        dataType: $event.length > 0 ? 'add' : 'remove'
      });
    }
  }, {
    key: "rowClickHandler",
    value: function rowClickHandler(row, column, $event) {
      var _this5 = this;

      if (this.isInvalidOrder(row) || this.isOrderIdExistInGlobal(row.id)) {
        return false;
      }

      var orderTable = this.helper.get(this.$refs, 'unassignedOrderTable', null);
      orderTable.toggleRowSelection(row); // Socket for global orders

      this.socketAPI.updateLMDGlobalSelectedOrders({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        orderId: [row.id],
        dataType: this.helper.findIndex(this.$selectedOrders, function (o) {
          return o['id'] === row['id'];
        }) === -1 ? 'add' : 'remove'
      });
      this.$selectedOrders = this.helper.findIndex(this.$selectedOrders, function (o) {
        return o['id'] === row['id'];
      }) === -1 ? this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(this.$selectedOrders), [row]), 'id') : this.helper.filter(this.$selectedOrders, function (o) {
        return o['id'] !== row['id'];
      });
      this.$selectedOrders.map(function (o) {
        var idx = _this5.helper.findIndex(_this5.$unassignedOrders, function (i) {
          return i['id'] === o['id'];
        });

        if (_this5.helper.isUndefined(o['tableIndex'])) {
          o['tableIndex'] = _this5.tableIndex(idx);
        }
      });
    }
  }, {
    key: "isSortable",
    value: function isSortable(colName) {
      return true;
    }
  }, {
    key: "toggleRowsSelection",
    value: function toggleRowsSelection(rows) {
      var orderTable = this.helper.get(this.$refs, 'unassignedOrderTable', null);

      var p = _objectSpread({}, this.$pagination);

      rows ? rows.forEach(function (row) {
        orderTable.toggleRowSelection(row);
      }) : orderTable.clearSelection();
      this.$setPagination(p);
      this.logger.info('toggleRowsSelection - Set pagination', JSON.stringify(this.$pagination));
    }
  }, {
    key: "showFailedOrders",
    value: function showFailedOrders() {
      this.$emit('onFailedOrders', {
        isShowFailedOrders: true,
        failedOrders: this.$failedOrders
      });
    }
  }, {
    key: "toggleOrderFullscreen",
    value: function toggleOrderFullscreen() {
      var el = this.helper.get(this.$refs, 'fullscreen', null);

      if (el) {
        el.toggleFullscreen(true);
      }
    }
  }, {
    key: "formatItemInfo",
    value: function formatItemInfo(itemInfo) {
      if (this.helper.isUndefined(itemInfo) || this.helper.isEmpty(itemInfo)) {
        return [];
      }

      return itemInfo.split(/\r?\n/);
    }
  }, {
    key: "isGenericStringColumns",
    value: function isGenericStringColumns(code) {
      return code === 'zone' || code === 'projectCode' || code === 'customerCode' || code === 'customerName' || code === 'shipmentReference' || code === 'soNumber' || code === 'commodityType' || code === 'serviceType' || code === 'serviceName' || code === 'serviceProviderName' || code === 'pickName' || code === 'dropName' || code === 'remarks' || code === 'seekCode' || code === 'userName';
    }
  }, {
    key: "isGenericNumberColumns",
    value: function isGenericNumberColumns(code) {
      return code === 'weight' || code === 'volume' || code === 'cartons' || code === 'pallets' || code === 'quantity' || code === 'assemblyMinutes' || code === 'wallMountQuantity' || code === 'disposalQuantity' || code === 'staircaseQuantity';
    }
  }, {
    key: "isGenericWaypointColumns",
    value: function isGenericWaypointColumns(code) {
      var waypointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'P';
      return waypointType === 'P' && (code === 'pickDateTime' || code === 'pickTimeWindow' || code === 'pickDistrict' || code === 'pickBuilding' || // code === 'pickLatLng' ||
      code === 'pickCompName' || code === 'pickPhoneNumber') || waypointType === 'D' && (code === 'dropDateTime' || code === 'dropTimeWindow' || code === 'dropDistrict' || code === 'dropBuilding' || // code === 'dropLatLng' ||
      code === 'dropCompName' || code === 'dropPhoneNumber');
    }
  }, {
    key: "isShowTableTooltip",
    value: function isShowTableTooltip(row) {
      return this.tableRowClassName({
        row: row
      }) === 'warning-row' || this.tableRowClassName({
        row: row
      }) === 'error-row' || this.tableRowClassName({
        row: row
      }) === 'used-row' || this.getInvalidOrderDetails(row)['reason6'] || this.getInvalidOrderDetails(row)['reason11'];
    }
  }, {
    key: "isShowReason",
    value: function isShowReason(row, reason) {
      return this.getInvalidOrderDetails(row)[reason];
    }
  }, {
    key: "isShowTitle",
    value: function isShowTitle(row) {
      return !this.getInvalidOrderDetails(row)['reason6'] && !this.getInvalidOrderDetails(row)['reason11'];
    }
  }, {
    key: "downloadExcel",
    value: function () {
      var _downloadExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var columns, assignedOrders, assignedIndex;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // const columns = this.$selectedColumns.map((col) => col['code']);
                columns = this.$selectedColumns;
                assignedOrders = [];
                assignedIndex = [];
                this.$plan.trucks.forEach(function (t) {
                  assignedOrders.push((0, _defineProperty2.default)({}, t.plateNumber, (0, _toConsumableArray2.default)(new Set((0, _toConsumableArray2.default)(t.orderId).map(Number)))));
                  var truck = (0, _defineProperty2.default)({}, t.plateNumber, (0, _toConsumableArray2.default)(t.routes.map(function (i) {
                    return i['orderId'];
                  })).map(function (trData) {
                    return (0, _toConsumableArray2.default)(new Set(trData.map(Number)));
                  }));
                  assignedIndex.push(truck);
                });
                _context3.next = 6;
                return this.orderAPI.downloadJobOrdersList({
                  dateRangeOption: this.$dateRangeOption,
                  startDate: this.$startDate,
                  endDate: this.$endDate,
                  excludedOrders: this.$excludedOrders,
                  includedOrders: this.$includedOrders,
                  searchType: this.$searchType,
                  orderFilters: this.$orderFilters,
                  pagination: this.$pagination,
                  userInformation: this.$userInformation,
                  planDate: this.$planDate
                }, 'lastmile', columns, assignedOrders, assignedIndex);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function downloadExcel() {
        return _downloadExcel.apply(this, arguments);
      }

      return downloadExcel;
    }()
  }, {
    key: "showOrderOnMap",
    value: function showOrderOnMap() {
      var _this6 = this;

      var waypoints = this.helper.flatten(this.$selectedOrders.map(function (i) {
        return i['waypoints'];
      }) || []);
      waypoints = waypoints.map(function (wp) {
        var matchedOrder = _this6.helper.find(_this6.$selectedOrders, function (i) {
          return i['id'] === wp['orderId'];
        });

        return _objectSpread(_objectSpread({}, wp), {}, {
          tableIndex: matchedOrder['tableIndex']
        });
      });
      window.localStorage.removeItem('tName');
      window.localStorage.removeItem('tContainerNum');
      window.localStorage.removeItem('tGpsId');
      window.localStorage.setItem('tData', this.helper.toString((0, _toConsumableArray2.default)(waypoints)));
      window.localStorage.setItem('tInitEvent', 'selectedOrderMarker');
      var routeData = this.$router.resolve({
        name: 'map'
      });
      window.open(routeData.href, this.$t('planning.orders'), 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=600, height=600');
    }
  }, {
    key: "tableIndex",
    value: function tableIndex(index) {
      return (this.$pagination['currentPage'] - 1) * this.$pagination['pageSize'] + index + 1;
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return LMDOrderTableComponent;
}((0, _vuePropertyDecorator.Mixins)(_loading.LoadingMixin, _lastMileV.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: '500px'
})], LMDOrderTableComponent.prototype, "tableHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$pageSize')], LMDOrderTableComponent.prototype, "onPageSizeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$unassignedOrders')], LMDOrderTableComponent.prototype, "onUnassignedOrdersChanges", null);
LMDOrderTableComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderTableComponent',
  components: {
    'order-table-column-selector': _orderTableColumnSelector.default,
    fullscreen: _fullscreen.default,
    'map-world': _mapWorld.default,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-pagination': _elementUi.Pagination,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-button': _elementUi.Button,
    'el-dialog': _elementUi.Dialog
  }
})], LMDOrderTableComponent);
var _default = LMDOrderTableComponent;
exports.default = _default;